import { useEffect, useState } from "react";

export function useVideoSource(videoUrl: string) {
  const [duration, setDuration] = useState(0);

  useEffect(() => {
    if (!videoUrl) return;
    let cancelled = false;

    // ici on recupère les metadata de la vidéo, grace a une fonction serveur qui utilise ffmpeg,
    // plus fiable que la récupération côté client et plus rapide que le DOM
    // si le serveur est indisponible, on utilise le DOM pour récupérer les metadata, mais d'une vidéo à l'autre, ça peut casser
    fetch(`https://ns3258217.ip-51-75-216.eu/get-video-metadata?url=${encodeURIComponent(videoUrl)}`)
      .then(res => res.json())
      .then(data => {
        if (!cancelled && data.duration && data.duration > 0) {
          setDuration(Number(data.duration));
        } else {
          const video = document.createElement("video");
          video.src = videoUrl;
          video.preload = "metadata";
          video.onloadedmetadata = () => {
            if (!cancelled && isFinite(video.duration) && video.duration > 0) {
              setDuration(video.duration);
            } else {
              try {
                video.currentTime = 1e10;
                video.ontimeupdate = () => {
                  if (!cancelled && isFinite(video.duration) && video.duration > 0) {
                    setDuration(video.duration);
                    video.ontimeupdate = null;
                  }
                };
              } catch (err) {}
            }
          };
        }
      })
      .catch(() => {
        const video = document.createElement("video");
        video.src = videoUrl;
        video.preload = "metadata";
        video.onloadedmetadata = () => {
          if (!cancelled && isFinite(video.duration) && video.duration > 0) {
            setDuration(video.duration);
          }
        };
      });

    return () => { cancelled = true; };
  }, [videoUrl]);

  return { duration };
}